export default __webpack_public_path__ + "static/media/Award.e402fa31.svg";